import React from 'react';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import HelpIcon from '../icons/HelpIcon';
import Typography from '../Typography';
import capitalize from '../lib/capitalize';

function Hint({ classes, messageId, className, position }) {
  return (
    <span className={classNames(classes.root, classes.icon, className)}>
      <HelpIcon color="primary" className={classes.icon} />
      <Typography
        className={classNames(classes.message, classes[`message${capitalize(position)}`])}
      >
        <FormattedMessage id={messageId} />
      </Typography>
    </span>
  );
}

Hint.propTypes = {
  classes: PropTypes.object.isRequired,
  messageId: PropTypes.string.isRequired,
  className: PropTypes.string,
  position: PropTypes.oneOf(['top', 'right']),
};

Hint.defaultProps = {
  className: undefined,
  position: 'right',
};

const stylesheet = theme => ({
  root: {
    position: 'relative',
    marginLeft: theme.spacing.unit,
    '&:hover $message': {
      opacity: 1,
    },
    '&:hover $messageTop': {
      transform: `translate(-50%, -${theme.spacing.unit / 2}px)`,
    },
    '&:hover $messageRight': {
      transform: `translate(${theme.spacing.unit / 2}px, -50%)`,
    },
  },
  icon: {
    width: theme.spacing.small,
    height: theme.spacing.small,
    verticalAlign: 'bottom',
    color: theme.palette.primary[500],
  },
  messageTop: {
    left: '50%',
    bottom: '100%',
    transform: 'translate(-50%, 0)',
  },
  messageRight: {
    top: '50%',
    left: '100%',
    transform: 'translate(0, -50%)',
  },
  message: {
    opacity: 0,
    position: 'absolute',
    width: 240,
    background: theme.palette.common.darkBlack,
    borderRadius: 4,
    padding: [[4, 8]],
    fontSize: 12,
    color: theme.palette.common.white,
    transition: theme.transitions.create(['transform', 'opacity']),
    pointerEvents: 'none',
    zIndex: 10,
  },
});

export default injectSheet(stylesheet)(Hint);



// WEBPACK FOOTER //
// ./src/site-render/src/Hint/Hint.js